// please use this pattern for all mixpanel events:
// "FEATURE__DETAILS_ABOUT_THE_EVENT" notice the double underscore after the feature name

// event names (the string value) should be easy to understand and describe why they matter in the users flow regarding the feature they are using
// try to describe what is happening in a human readable way
// use words like "navigated", "contacted", "sent", "closed" etc instead of just "clicked"

// event constant names do not need to be as descriptive, they are only dev facing

// Customer Self Checkout
const CUSTOMER_SELF_CHECKOUT__CLICKED_CONTINUE_CTA_CONFIRM_OFFER_PAGE =
  "Customer Self Checkout - Navigated to Checkout with 'Continue' CTA from Confirm Offer";

const CUSTOMER_SELF_CHECKOUT__CLICKED_CONTACT_SALES_REP_CTA_OFFER_REVIEW_PAGE =
  "Customer Self Checkout - Clicked 'Contact Sales Rep' CTA on Offer Review";

const CUSTOMER_SELF_CHECKOUT__CLICKED_CHECKOUT_CTA_ON_OFFER_REVIEW_PAGE =
  "Customer Self Checkout - Navigated to Confirm Offer with 'Checkout' CTA from Offer Review";

const CUSTOMER_SELF_CHECKOUT__CLICKED_PHONE_SALES_REP_CTA_OFFER_REVIEW_PAGE =
  "Customer Self Checkout - Attempted to contact sales rep via Phone in 'Contact Sales Rep' modal on Offer Review";

const CUSTOMER_SELF_CHECKOUT__CLICKED_EMAIL_SALES_REP_CTA_OFFER_REVIEW_PAGE =
  "Customer Self Checkout - Attempted to contact sales rep via Email in 'Contact Sales Rep' modal on Offer Review";

const CUSTOMER_SELF_CHECKOUT__CLICKED_EMAIL_SALES_REP_CTA_OFFER_SELECTOR_PAGE =
  "Customer Self Checkout - Attempted to contact sales rep via Email in 'Contact Sales Rep' modal on Offer Selector";

const CUSTOMER_SELF_CHECKOUT__CLICKED_PHONE_SALES_REP_CTA_OFFER_SELECTOR_PAGE =
  "Customer Self Checkout - Attempted to contact sales rep via Phone in 'Contact Sales Rep' modal on Offer Selector";

const CUSTOMER_SELF_CHECKOUT__CLICKED_SEND_MESSAGE_SALES_REP_CTA_OFFER_REVIEW_PAGE =
  "Customer Self Checkout - Attempted to contact sales rep via Send Message in 'Contact Sales Rep' modal on Offer Review";

const CUSTOMER_SELF_CHECKOUT__CLICKED_SEND_MESSAGE_SALES_REP_CTA_OFFER_SELECTOR_PAGE =
  "Customer Self Checkout - Attempted to contact sales rep via Send Message in 'Contact Sales Rep' modal on Offer Selector";

const CUSTOMER_SELF_CHECKOUT__CLICKED_CONTINUE_CTA_CONFIRM_NAMES_TAB_CHECKOUT_PAGE =
  "Customer Self Checkout - Navigated to next Checkout step with 'Continue' CTA from 'Confirm Names' tab";

const CUSTOMER_SELF_CHECKOUT__CLICKED_CONFIRM_CTA_READ_AND_SIGN_TAB_CHECKOUT_PAGE =
  "Customer Self Checkout - Navigated to next Checkout step with 'Confirm' CTA from 'Read and Sign' tab";

const CUSTOMER_SELF_CHECKOUT__CHECKOUT_PAGE_LOADED =
  "Customer Self Checkout - Checkout Page was loaded";

const CUSTOMER_SELF_CHECKOUT__CLICKED_EMAIL_DOCUMENT_IN_MODAL_CHECKOUT =
  "Customer Self Checkout - Sent Document via Email in 'Send Document' modal from Read and Sign docs tab in Checkout";

const CUSTOMER_SELF_CHECKOUT__CLICKED_TEXT_MESSAGE_DOCUMENT_IN_MODAL_CHECKOUT =
  "Customer Self Checkout - Sent Document via Text Message in 'Text Document' modal from Read and Sign docs tab in Checkout";

const CUSTOMER_SELF_CHECKOUT__CLICKED_RUN_CREDIT_CHECK_IN_CHECKOUT =
  "Customer Self Checkout - Clicked 'Run Credit Check' CTA in Credit Check tab in Checkout";

const CUSTOMER_SELF_CHECKOUT__PAYMENT_SUCCESS_ON_PAY_DEPOSIT_TAB_IN_CHECKOUT =
  "Customer Self Checkout - Payment Success returned on 'Pay Deposit' tab in Checkout";

const CUSTOMER_SELF_CHECKOUT__CLICKED_SEND_INTRO_MESSAGE_TO_CUSTOMER_IN_CUSTOMER_APP_TASK_VIEW =
  "Customer Self Checkout - Clicked 'Send intro message to customer' CTA in Customer App Task View";

const CUSTOMER_SELF_CHECKOUT__CLICKED_SEND_FOLLOW_UP_MESSAGE_IN_CUSTOMER_APP_TASK_VIEW =
  "Customer Self Checkout - Clicked 'Send a follow-up message (Optional)' CTA in Customer App Task View";

const CUSTOMER_SELF_CHECKOUT__CLICKED_SEND_EMAIL_TO_CUSTOMER_IN_CUSTOMER_APP_TASK_VIEW =
  "Customer Self Checkout - Clicked 'Send email to customer' CTA in Customer App Task View";

const CUSTOMER_SELF_CHECKOUT__COMBINED_SIGN_ERROR =
  "Customer Self Checkout - Combined Sign Error";

const SALES_REP_CHECKOUT__COMBINED_SIGN_ERROR =
  "Sales Rep Checkout - Combined Sign Error";

const OFFER_CREATION__CLICKED_CONTINUE_ON_PRODUCT_SELECTION_PAGE =
  "Offer Creation - Clicked 'Continue' CTA on bundle selection page";

const OFFER_CREATION__SUBMIT_OFFER =
  "Offer Creation - Submitted offer via submit CTA on pricing page";

const CAP__NAVIGATED_TO_REP_REDESIGN_FROM_MAKE_MY_OWN_CHANGES_ON_DESIGN_STEP =
  "CAP - Navigated to Rep Redesign with 'Make my own changes' CTA from Design Step";

const CUSTOMER_SELF_CHECKOUT__RISK_RE_SIGNING_FROM_CONFIRM_NAMES_MODAL =
  "Customer Self Checkout - Risk re-signing from Confirm Names modal";

const CUSTOMER_SELF_CHECKOUT__RISK_RE_SIGNING_FROM_UTILITY_BILL_MISSING_MODAL =
  "Customer Self Checkout - Risk re-signing from Utility Bill Missing modal";

export {
  CUSTOMER_SELF_CHECKOUT__CLICKED_CONTINUE_CTA_CONFIRM_OFFER_PAGE,
  CUSTOMER_SELF_CHECKOUT__CLICKED_CONTACT_SALES_REP_CTA_OFFER_REVIEW_PAGE,
  CUSTOMER_SELF_CHECKOUT__CLICKED_CHECKOUT_CTA_ON_OFFER_REVIEW_PAGE,
  CUSTOMER_SELF_CHECKOUT__CLICKED_PHONE_SALES_REP_CTA_OFFER_REVIEW_PAGE,
  CUSTOMER_SELF_CHECKOUT__CLICKED_EMAIL_SALES_REP_CTA_OFFER_REVIEW_PAGE,
  CUSTOMER_SELF_CHECKOUT__CLICKED_EMAIL_SALES_REP_CTA_OFFER_SELECTOR_PAGE,
  CUSTOMER_SELF_CHECKOUT__CLICKED_PHONE_SALES_REP_CTA_OFFER_SELECTOR_PAGE,
  CUSTOMER_SELF_CHECKOUT__CLICKED_SEND_MESSAGE_SALES_REP_CTA_OFFER_REVIEW_PAGE,
  CUSTOMER_SELF_CHECKOUT__CLICKED_SEND_MESSAGE_SALES_REP_CTA_OFFER_SELECTOR_PAGE,
  CUSTOMER_SELF_CHECKOUT__CLICKED_CONTINUE_CTA_CONFIRM_NAMES_TAB_CHECKOUT_PAGE,
  CUSTOMER_SELF_CHECKOUT__CLICKED_CONFIRM_CTA_READ_AND_SIGN_TAB_CHECKOUT_PAGE,
  CUSTOMER_SELF_CHECKOUT__CHECKOUT_PAGE_LOADED,
  CUSTOMER_SELF_CHECKOUT__CLICKED_EMAIL_DOCUMENT_IN_MODAL_CHECKOUT,
  CUSTOMER_SELF_CHECKOUT__CLICKED_TEXT_MESSAGE_DOCUMENT_IN_MODAL_CHECKOUT,
  CUSTOMER_SELF_CHECKOUT__CLICKED_RUN_CREDIT_CHECK_IN_CHECKOUT,
  CUSTOMER_SELF_CHECKOUT__PAYMENT_SUCCESS_ON_PAY_DEPOSIT_TAB_IN_CHECKOUT,
  CUSTOMER_SELF_CHECKOUT__CLICKED_SEND_INTRO_MESSAGE_TO_CUSTOMER_IN_CUSTOMER_APP_TASK_VIEW,
  CUSTOMER_SELF_CHECKOUT__CLICKED_SEND_FOLLOW_UP_MESSAGE_IN_CUSTOMER_APP_TASK_VIEW,
  CUSTOMER_SELF_CHECKOUT__CLICKED_SEND_EMAIL_TO_CUSTOMER_IN_CUSTOMER_APP_TASK_VIEW,
  OFFER_CREATION__CLICKED_CONTINUE_ON_PRODUCT_SELECTION_PAGE,
  OFFER_CREATION__SUBMIT_OFFER,
  CAP__NAVIGATED_TO_REP_REDESIGN_FROM_MAKE_MY_OWN_CHANGES_ON_DESIGN_STEP,
  CUSTOMER_SELF_CHECKOUT__COMBINED_SIGN_ERROR,
  SALES_REP_CHECKOUT__COMBINED_SIGN_ERROR,
  CUSTOMER_SELF_CHECKOUT__RISK_RE_SIGNING_FROM_CONFIRM_NAMES_MODAL,
  CUSTOMER_SELF_CHECKOUT__RISK_RE_SIGNING_FROM_UTILITY_BILL_MISSING_MODAL,
};
